import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { fetchAllTrainersByExpLvlData } from "../../redux/reducers/apiSlice";
import Loader from "../ui/Loader";
import { showConfirmAlert } from "../components-react/ReactAlert";
// import { gender } from "../common-data/DropdowData";
import SelectDropdown from "../components-react/SelectDropdown";
import { fetchMemberSubscriptionData } from "../../redux/plans-reducers/plansSlice";
import { convertThenFormat, formatDateTimezon } from "../common-data/Converts";
import { getSubsProgress } from "../pt/pt-flow-new/users-info/calculations";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { post_pt_transfer } from "../../data/ApiEndpoints";
import { fetchTrainerShiftsData } from "../../redux/reducers/dropdownApiSlice";
import { selectGymData } from "../../redux/reducers/gymDataSlice";
// import { fetchGymData } from "../../data/APIs";

const validateForm = (formValues) => {
  let errors = {};
  const mobileRegex = /^\d{10}$/;

  if (!formValues.memberMobile) {
    errors.memberMobile = "Member Number Required!";
  } else if (!mobileRegex.test(formValues.memberMobile)) {
    errors.memberMobile = "invalid mobile number!";
  }

  if (!formValues.subscriptionId) {
    errors.subscriptionId = "Required!";
  }

  if (!formValues.selectedTrainer) {
    errors.selectedTrainer = "Required!";
  }

  if (!formValues.selectedSlotIndex) {
    errors.selectedSlotIndex = "Required!";
  }

  return errors;
};

const PTTransferForm = ({ userInfoData, callFunction, closeModal }) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const { postPutLoading } = useSelector((state) => state.common);
  const {
    memberSubscription,
    memberSubscriptionLoading,
    memberSubscriptionError,
  } = useSelector((state) => state.plans);
  const {
    allTrainerByExpLvlData,
    loading: trainerLoading,
    error,
  } = useSelector((state) => state.api);
  const { trainerShifts, loading: trainerSlotLoading } = useSelector(
    (state) => state.dropdown
  );

  const [isFetchUser, setIsFetchUser] = useState(false);
  const [memberFetchedData, setMemberFetchedData] = useState(null);
  const iniMemStatus = {
    isShowForm: false,
    errorMessage: "",
  };
  const [memberStatus, setMemberStatus] = useState(iniMemStatus);

  const [allGymTrainers, setAllGymTrainers] = useState([]);

  const iniFormValues = {
    subscriptionId: "",
    memberMobile: "",
    memberName: "",
    memberEmail: "",
    userId: "",
    selectedSlotIndex: "",
    selectedSlotStartTime: "",
    selectedSlotEndTime: "",
    selectedTrainer: "",
    remarks: "",
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    const file = type === "file" ? e.target.files[0] : null;

    setIsSubmit(false);

    setFormValues((prevs) => ({
      ...prevs,
      [name]: type === "checkbox" ? checked : type === "file" ? file : value,
    }));
  };

  const onChangeDropdown = (name, value) => {
    setIsSubmit(false);

    if (name === "selectedTrainer") {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
        selectedSlotIndex: "",
        selectedSlotStartTime: "",
        selectedSlotEndTime: "",
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSelect = (subsId) => {
    setFormValues((prevs) => ({
      ...prevs,
      subscriptionId: subsId === prevs.subscriptionId ? "" : subsId,
      selectedSlotIndex: "",
      selectedSlotStartTime: "",
      selectedSlotEndTime: "",
      selectedTrainer: "",
    }));
  };

  const handleSelectSlot = (index, start, end) => {
    if (index === formValues.selectedSlotIndex) {
      setFormValues((prevs) => ({
        ...prevs,
        selectedSlotIndex: "",
        selectedSlotStartTime: "",
        selectedSlotEndTime: "",
      }));
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        selectedSlotIndex: index,
        selectedSlotStartTime: start,
        selectedSlotEndTime: end,
      }));
    }
  };

  const onSumitForm = (e) => {
    e.preventDefault();
    setFormErrors(validateForm(formValues));
    setIsSubmit(true);
  };

  function getMemberDetails(filters) {
    dispatch(
      fetchMemberSubscriptionData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function onClickFetchUserDetails(e) {
    e.preventDefault();

    if (formValues.memberMobile && !formErrors.memberMobile) {
      const filters = {
        mobile_number: formValues.memberMobile,
        type: "addon_pt",
      };

      setIsFetchUser(true);
      getMemberDetails(filters);
    }
  }

  function onClearNumber(e) {
    e && e.preventDefault();

    const handleConfirm = () => {
      setFormValues(iniFormValues);
      setIsSubmit(false);
      setIsFetchUser(false);
      setMemberFetchedData(null);
    };

    showConfirmAlert(handleConfirm, `You want to clear the form?`);
  }

  const handleSubmitForm = async (payload) => {
    const method = "POST";
    const endpoint = post_pt_transfer;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(iniFormValues);
        setIsFetchUser(false);
        setMemberFetchedData(null);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage =
          result?.payload?.data ||
          result?.payload?.message ||
          result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (
      isFetchUser &&
      !memberSubscriptionLoading &&
      !formErrors.memberMobile &&
      !memberSubscriptionError &&
      memberSubscription?.status &&
      memberSubscription?.data?.length > 0
    ) {
      const memberData = memberSubscription.data;
      const { gym_name, gym_id, user_id, user_name, user_email } =
        memberSubscription.data[0];

      setFormValues((prevs) => ({
        ...prevs,
        userId: user_id,
        memberName: user_name,
        memberEmail: user_email,
        selectedGym: {
          label: gym_name,
          value: gym_id,
        },
      }));

      setMemberFetchedData(memberData);
      setMemberStatus({
        isShowForm: true,
        errorMessage: "",
      });
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        userId: "",
        memberName: "",
        memberEmail: "",
        selectedGym: "",
      }));
      setMemberFetchedData(null);
      setMemberStatus(iniMemStatus);
      return;
    }
  }, [
    isFetchUser,
    memberSubscriptionLoading,
    memberSubscriptionError,
    formErrors.memberMobile,
  ]);

  useEffect(() => {
    if (formValues.selectedGym?.value) {
      const qp = `&gym_id=${formValues.selectedGym.value}&status=active`;

      dispatch(
        fetchAllTrainersByExpLvlData({
          queryParameters: qp,
          token: userInfoData?.token,
        })
      );
    }
  }, [formValues.selectedGym]);

  useEffect(() => {
    if (formValues.selectedTrainer?.value) {
      const filter = {
        trainer_id: formValues.selectedTrainer.value,
      };

      dispatch(
        fetchTrainerShiftsData({
          filters: filter,
          token: userInfoData?.token,
        })
      );
    }
  }, [formValues.selectedTrainer]);

  // useEffect(() => {
  //   dispatch(fetchGymData(userInfoData?.token));
  // }, []);

  useEffect(() => {
    if (
      !trainerLoading &&
      !error &&
      allTrainerByExpLvlData?.status &&
      allTrainerByExpLvlData?.data
    ) {
      const slots = allTrainerByExpLvlData.data?.slot_details || [];
      const trainers = allTrainerByExpLvlData.data?.map((item) => ({
        value: item.user_id,
        label: item.name,
        slot: slots,
        info: item,
      }));

      setAllGymTrainers(trainers);
    } else {
      setAllGymTrainers([]);
    }
  }, [trainerLoading, error, allTrainerByExpLvlData]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        subscription_id: formValues.subscriptionId || "",
        transferred_to: formValues.selectedTrainer?.value || "",
        transferred_reason: formValues.remarks || "",
        slot_start_time: formValues.selectedSlotStartTime || "",
        slot_end_time: formValues.selectedSlotEndTime || "",
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  console.log("formErrors=> ", formErrors);

  return (
    <div className="form-container">
      <CommonHeadingNBtns
        title={`PT Transfer`}
        onClose={closeModal}
        onClick={onSumitForm}
        isLoading={postPutLoading}
        isDisabled={!memberStatus.isShowForm}
      />

      <form className="formContainer" style={{ marginTop: "30px" }}>
        <div className="formInputsGrid twoGridSystem input-with-btn">
          <div className="formInputBox">
            <label htmlFor="memberMobile" className={`formInputLabel`}>
              member mobile <span className="required">*</span>
            </label>

            <input
              type="number"
              placeholder="Enter Member Mobile Number"
              className={`formInput ${
                formErrors?.memberMobile ? "formError" : ""
              }`}
              name="memberMobile"
              value={formValues.memberMobile}
              onChange={onChangeInput}
            />

            <span className="error-label">
              {formErrors?.memberMobile || ""}
            </span>

            {!memberStatus.isShowForm && memberStatus.errorMessage && (
              <span className="info">{memberStatus.errorMessage || ""}</span>
            )}
          </div>

          <div className="formInputButtons">
            <Button
              type="button"
              className="saveBtn"
              variant="danger"
              onClick={onClickFetchUserDetails}
              disabled={memberFetchedData || formErrors.memberMobile}>
              {memberSubscriptionLoading ? <Loader /> : "Fetch Member Details"}
            </Button>
            {!memberSubscriptionLoading && (
              <Button
                type="button"
                className="cancelBtn"
                variant="dark"
                onClick={onClearNumber}>
                Clear
              </Button>
            )}
          </div>
        </div>

        {memberStatus.isShowForm && (
          <>
            <div className="formInputsGrid fourGridSystem">
              <div className="formInputBox">
                <label htmlFor="memberName" className={`formInputLabel`}>
                  member Name
                </label>

                <input
                  type="text"
                  placeholder="Enter Member Full Name"
                  className={`formInput ${
                    formErrors?.memberName ? "formError" : ""
                  }`}
                  name="memberName"
                  value={formValues.memberName}
                  onChange={onChangeInput}
                  disabled
                />
              </div>

              <div className="formInputBox">
                <label htmlFor="memberMobile" className={`formInputLabel`}>
                  member mobile
                </label>

                <input
                  type="email"
                  placeholder="Enter Member Mobile"
                  className={`formInput ${
                    formErrors?.memberMobile ? "formError" : ""
                  }`}
                  name="memberMobile"
                  value={formValues.memberMobile}
                  onChange={onChangeInput}
                  disabled
                />
              </div>

              <div className="formInputBox">
                <label htmlFor="memberEmail" className={`formInputLabel`}>
                  member email
                </label>

                <input
                  type="email"
                  placeholder="Enter Member Email"
                  className={`formInput ${
                    formErrors?.memberEmail ? "formError" : ""
                  }`}
                  name="memberEmail"
                  value={formValues.memberEmail}
                  onChange={onChangeInput}
                  disabled
                />
              </div>

              <div className="formInputBox">
                <label htmlFor="selectedGym" className={`formInputLabel`}>
                  gym name
                </label>

                <div
                  className={`commonWrapper disabled ${
                    formErrors.selectedGym ? "formError" : ""
                  }`}>
                  <SelectDropdown
                    options={gymData?.length > 0 ? gymData : []}
                    selectedOption={formValues.selectedGym}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("selectedGym", selectedValue)
                    }
                    name="Gym"
                    isDisable={true}
                  />
                </div>
              </div>
            </div>

            <div className="membership-details plan-details grid-box-clickables">
              {memberFetchedData?.map((item, index) => {
                const {
                  type,
                  plan_name,
                  addon_name,
                  subscription_status,
                  trainer_name,
                  sub_added_by_name,
                  sub_added_by_mobile,
                  sub_added_by_email,
                  price,
                  start_date,
                  expire_date,
                  completed_session,
                  n_session,
                  uid,
                } = item || {};

                const planName =
                  type === "regular"
                    ? plan_name
                    : type === "addon_pt"
                    ? addon_name
                    : type;

                const isActive = subscription_status === "active";

                const planStatusBg = isActive ? "#09BA09" : "#BA0934";

                const startDate = start_date
                  ? formatDateTimezon(start_date)
                  : "-";
                const endDate = expire_date
                  ? formatDateTimezon(expire_date)
                  : "-";

                const daysLeft = getSubsProgress(
                  start_date,
                  expire_date
                ).daysLeft;

                const isCardSelected = uid === formValues.subscriptionId;

                return (
                  <div
                    className={`membership-plans ${
                      isCardSelected ? "active" : ""
                    } ${formErrors?.subscriptionId ? "formError" : ""}`}
                    key={index}>
                    <div className="plan-col icon">
                      <div className="icon-box">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="35"
                          height="36"
                          viewBox="0 0 35 36"
                          fill="none">
                          <path
                            d="M11.0452 15.7383C8.30438 15.7383 6.07812 17.9591 6.07812 20.7054C6.07812 23.4516 8.29896 25.6724 11.0452 25.6724C13.786 25.6724 16.0123 23.4516 16.0123 20.7054C16.0123 17.9591 13.786 15.7383 11.0452 15.7383ZM11.0452 24.1395C9.14396 24.1395 7.60563 22.6012 7.60563 20.6999C7.60563 18.7987 9.14396 17.2604 11.0452 17.2604C12.9465 17.2604 14.4848 18.7987 14.4848 20.6999C14.4848 22.6012 12.941 24.1395 11.0452 24.1395Z"
                            fill="#1B1A1A"
                          />
                          <path
                            d="M29.1396 8.32974L27.2871 4.39724C26.9783 3.85016 26.4529 3.94766 26.2687 4.03433L15.5058 9.10433C15.1917 9.25599 15.0129 9.59724 15.0833 9.94391L15.2404 10.7347L12.4346 12.0564L11.9254 11.4335C11.7033 11.1627 11.3242 11.076 11.01 11.2277L7.38625 12.9339C3.10167 14.9543 1.26 20.0839 3.28042 24.3631C3.535 24.9102 3.85458 25.4139 4.21208 25.8797C3.05833 26.2481 2.21875 27.3314 2.21875 28.6097C2.21875 30.1914 3.5025 31.4752 5.08417 31.4752C6.63875 31.4752 7.90083 30.2402 7.94417 28.6964C8.92458 29.081 9.97542 29.2868 11.0533 29.2868C11.0533 29.2868 13.09 29.2435 14.7096 28.4635C18.9779 26.4106 20.8358 21.3135 18.8154 17.0343C18.6637 16.7147 18.4958 16.406 18.3008 16.1027L28.8687 9.28849C29.1829 9.08808 29.3021 8.67641 29.1396 8.32974ZM5.07333 29.9531C4.33667 29.9531 3.74083 29.3518 3.74083 28.6152C3.74083 27.8785 4.34208 27.2772 5.07875 27.2772C5.81542 27.2772 6.41667 27.8785 6.41667 28.6152C6.41667 29.3518 5.81542 29.9531 5.07333 29.9531ZM16.8004 15.2577C16.1017 15.7127 16.4808 16.2002 16.6108 16.3681C16.9304 16.7797 17.2067 17.2293 17.4288 17.6952C19.0863 21.216 17.5696 25.4247 14.0542 27.0931C12.7054 27.7322 11.0479 27.7702 11.0479 27.7702C8.32333 27.7702 5.81542 26.1777 4.65625 23.7185C2.99875 20.1977 4.51 15.9835 8.03083 14.3206L11.1183 12.8635L11.6275 13.4864C11.8496 13.7572 12.2287 13.8439 12.5429 13.6922L16.4267 11.8614C16.7408 11.7097 16.9196 11.3685 16.8492 11.0218L16.6921 10.231L26.2254 5.73516L27.4658 8.37308L16.8004 15.2577Z"
                            fill="#1B1A1A"
                          />
                          <path
                            d="M25.5874 19.8524L26.4466 23.0588L27.3268 21.5342C29.0114 22.5068 29.5881 24.6591 28.6155 26.3437C28.3177 26.8595 27.9094 27.2675 27.4393 27.5653L27.7529 28.7356C28.5106 28.3328 29.1712 27.7284 29.6319 26.9305C30.9287 24.6843 30.1598 21.8147 27.9136 20.5178L28.7938 18.9932L25.5874 19.8524ZM23.806 27.6325C22.1213 26.6598 21.5446 24.5075 22.5172 22.8229C22.815 22.3071 23.2234 21.8991 23.6934 21.6013L23.3798 20.431C22.6222 20.8338 21.9615 21.4382 21.5009 22.2361C20.204 24.4823 20.973 27.352 23.2192 28.6488L22.3389 30.1734L25.5453 29.3143L24.6862 26.1079L23.806 27.6325Z"
                            fill="#1B1A1A"
                          />
                        </svg>
                      </div>
                      <div className="plan-name-and-status flexBetween">
                        <h3 className="plan-name">{planName || "NA"}</h3>
                        <span
                          className="plan-status"
                          style={{
                            background: planStatusBg,
                          }}>
                          {subscription_status || "NA"}
                        </span>
                      </div>
                    </div>

                    <div className="plan-col details">
                      <div className="info-label-and-value">
                        <span className="label">trainer name:</span>
                        <span className="value">{trainer_name || "NA"}</span>
                      </div>
                      <div className="info-label-and-value">
                        <span className="label">Amount Paid:</span>
                        <span className="value">
                          ₹{convertThenFormat(price || 0)}
                        </span>
                      </div>
                      <div className="info-label-and-value">
                        <span className="label">Plan Duration:</span>
                        <span className="value">
                          {startDate} - {endDate}
                        </span>
                      </div>
                      {type === "addon_pt" && (
                        <div className="info-label-and-value">
                          <span className="label">Session Status:</span>
                          <span className="value">
                            {completed_session || 0} / {n_session || 0}
                          </span>
                        </div>
                      )}
                      <div className="info-label-and-value">
                        <span className="label">Days Left:</span>
                        <span
                          className="value"
                          style={{
                            padding: "2px 5px",
                            background: "#0A4CCC",
                            color: "#fff",
                            borderRadius: "5px",
                          }}>
                          {daysLeft || 0}
                        </span>
                      </div>
                      <div className="info-label-and-value">
                        <span className="label">subscription added by:</span>
                        <span className="value">
                          {sub_added_by_name || "NA"}
                          <br />
                          {(sub_added_by_mobile || sub_added_by_email) && (
                            <small className="lowercase">
                              {sub_added_by_mobile || ""}
                              <br />
                              {sub_added_by_email || ""}
                            </small>
                          )}
                        </span>
                      </div>
                    </div>

                    <div className="plan-col btns">
                      <Button
                        type="button"
                        className="saveBtn"
                        variant="danger"
                        onClick={() => handleSelect(uid)}
                        disabled={isActive ? false : true}
                        style={{
                          cursor: isActive ? "pointer" : "not-allowed",
                          background: isCardSelected ? "#00712d" : "",
                          border: "none",
                          textTransform: "uppercase",
                        }}>
                        {isCardSelected ? "selected" : "select to transfer"}
                      </Button>
                    </div>
                  </div>
                );
              })}
            </div>

            {formValues.subscriptionId && (
              <div
                className="formInputsGrid fourGridSystem"
                style={{ rowGap: "1rem" }}>
                <div className="formInputBox span2">
                  <label htmlFor="selectedTrainer" className={`formInputLabel`}>
                    select trainer <span className="required">*</span>
                  </label>

                  <div
                    className={`commonWrapper ${
                      formErrors.selectedTrainer ? "formError" : ""
                    }`}>
                    <SelectDropdown
                      options={allGymTrainers}
                      selectedOption={formValues.selectedTrainer}
                      setSelectedOption={(selectedValue) =>
                        onChangeDropdown("selectedTrainer", selectedValue)
                      }
                      name="Trainer"
                      isDisable={trainerLoading}
                    />
                  </div>

                  <span className="error-label">
                    {formErrors?.selectedTrainer || ""}
                  </span>
                </div>

                {formValues.selectedTrainer?.value && (
                  <>
                    {trainerSlotLoading ? (
                      <Loader />
                    ) : trainerShifts?.length > 0 ? (
                      <div className="formInputBox span4">
                        <label
                          htmlFor="selectedSlotIndex"
                          className="formInputLabel">
                          Select Slot <span className="required">*</span>
                        </label>

                        <div
                          className={`flexWrapMultiBoxontainerSub ${
                            formErrors.selectedSlotIndex ? "formError" : ""
                          }`}
                          style={{
                            border: "1px solid #bbbbbb",
                            background: "#fff",
                            boxShadow: "none",
                            borderRadius: "8px",
                          }}>
                          {trainerShifts.map((slot, index) => {
                            const { start_time, end_time, is_available } =
                              slot?.info || {};
                            const isAvailble = is_available ? 1 : 0;

                            return (
                              <div
                                className={`wrappedBox ${
                                  !isAvailble ? "disabledSlot" : ""
                                } ${
                                  formValues.selectedSlotIndex === index + 1
                                    ? "selected"
                                    : ""
                                }`}
                                style={{
                                  cursor: !isAvailble
                                    ? "not-allowed"
                                    : "pointer",
                                }}
                                key={index}
                                onClick={() =>
                                  isAvailble &&
                                  handleSelectSlot(
                                    index + 1,
                                    start_time,
                                    end_time
                                  )
                                }
                                disabled={!isAvailble}>
                                <span className="wappedValueLabel textSmol">
                                  {slot?.label || "-"}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    ) : (
                      <span
                        className="errorMessage span4"
                        style={{ margin: "0" }}>
                        Slots Not Available
                      </span>
                    )}
                  </>
                )}

                <div className="formInputBox span4">
                  <label htmlFor="remarks" className="formInputLabel">
                    remarks
                  </label>

                  <textarea
                    name="remarks"
                    className={`formInput ${formErrors.remarks && "formError"}`}
                    style={{
                      minHeight: "60px",
                    }}
                    placeholder="Enter PT Transfer Reason"
                    value={formValues.remarks}
                    onChange={onChangeInput}></textarea>

                  <span className="error-label">
                    {formErrors?.remarks || ""}
                  </span>
                </div>
              </div>
            )}
          </>
        )}
      </form>
    </div>
  );
};

export default PTTransferForm;
